import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { checkOut, createCheckIn, getCheckInSummary, getMyCheckIn } from "./api";

export function useMyCheckIn() {
  return useQuery({
    queryKey: ["check-in", "me"],
    queryFn: getMyCheckIn,
    staleTime: 30_000,
  });
}

export function useCheckInSummary(stationId: string | undefined) {
  return useQuery({
    queryKey: ["check-in-summary", stationId],
    queryFn: () => getCheckInSummary(stationId!),
    enabled: !!stationId,
    staleTime: 20_000,
  });
}

export function useCheckIn() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createCheckIn,
    onSuccess: (_data, variables) => {
      qc.invalidateQueries({ queryKey: ["check-in", "me"] });
      qc.invalidateQueries({ queryKey: ["check-in-summary", variables.station_id] });
    },
  });
}

export function useCheckOut(stationId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: checkOut,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["check-in", "me"] });
      qc.invalidateQueries({ queryKey: ["check-in-summary", stationId] });
    },
  });
}
